<template>
    <div v-if="podcast" class="w-full">
        <PageHeader type="Podcast" :title="podcast.title" :image="podcast.image">
            <template #meta>
                <span class="font-semibold text-white" v-html="podcast.host"></span>
                <span class="mx-1">·</span>{{ podcast.episodes_count }} {{ podcast.episodes_count === 1 ? 'episode' : 'episodes' }}
            </template>
        </PageHeader>

        <div class="grid grid-cols-1 gap-12 lg:grid-cols-12">
            <section class="lg:col-span-8">
                <h2 class="nl-section-title mb-2">All episodes</h2>
                <ul v-if="podcast.episodes && podcast.episodes.length" class="divide-y divide-white/[0.06]">
                    <template v-for="(episode, index) in podcast.episodes" :key="episode.id">
                        <li><episode-card :episode="episode" /></li>
                        <li v-if="index === 2 && podcast.episodes.length > 3" class="py-6"><AdSlot placement="listFeed" /></li>
                    </template>
                </ul>
                <p v-else class="py-10 text-nomad-400">No episodes available.</p>
            </section>
            <aside v-if="podcast.description" class="lg:col-span-4">
                <h2 class="nl-section-title mb-3">About</h2>
                <p class="text-sm leading-relaxed text-nomad-300">{{ podcast.description }}</p>
            </aside>
        </div>
    </div>
</template>
<script setup>
import PageHeader from "@/components/ui/PageHeader.vue";
defineProps({ podcast: Object });
</script>
<script>
import AdSlot from "@/components/ui/AdSlot.vue";
import { defineAsyncComponent } from 'vue'
import { mapState, mapActions } from "vuex";
import { usePage } from "@inertiajs/vue3";
import EpisodeCard from "@/components/EpisodeCard.vue";
export default {
    methods: {
        ...mapActions("podcast", ["getSignlePodcast"]),
    },
    beforeMount() {
        document.title = this.podcast.title + ' by ' + this.podcast.host
    },
    components: {
        AdSlot,
        EpisodeCard,
    }
};
</script>
